<template>
  <div class="login">
    <div class="login__form-admin">
      <h2 class="login__title">Bienvenido</h2>
      <p class="login__description">Crea, monitorea y edita tu solicitud de ingreso.</p>
      <div style="max-width: 40rem; margin-left: auto; margin-right: auto;" class="form__group">
        <label class="form__label">Correo electrónico:</label>
        <input @keyup.enter="handleAuth" v-model="email" type="email" class="form__input" />
        <validation-error :validation="$v.email"></validation-error>
      </div>
      <div style="max-width: 40rem; margin-left: auto; margin-right: auto;" class="form__group">
        <label class="form__label">Contraseña:</label>
        <input
          @keyup.enter="handleAuth"
          :type="passwordVisible"
          v-model="password"
          class="form__input input-password"
        />
        <img
          @mousedown="togglePwdIcon(true)"
          @mouseup="togglePwdIcon(false)"
          @mouseleave="togglePwdIcon(false)"
          :src="'/img/icons/'+showPasswordIcon"
          class="show-password"
        />
        <validation-error :validation="$v.password"></validation-error>
      </div>
      <div class="form__group">
        <btn @onClick="handleAuth" v-if="loggin" type="primary-block" text="Iniciar Sesión" />
        <p class="text-primary animated fadeInLeft" v-else>Cargando...</p>
        <p class="forgot-password" style="font-size: 16px;" @click="$refs.forgotpwd.toggleModal()">¿Olvidaste tu contraseña?</p>
        <p class="not-registered" style="font-size: 16px;">
          No cuento con una cuenta
          <span class="create-account">
            <router-link to="/register">Crear Cuenta</router-link>
          </span>
        </p>
        <p style="font-size: 16px; font-weight: 600; color: #828282"> <router-link to="/help">Videos</router-link> de ayuda 
        | Lista de 
          <span @click="donwloadFile('https://kiritek-web-documents.s3-us-west-2.amazonaws.com/solicitudes/ListaDocumentos.pdf')" style="color: #007bff; cursor: pointer;">
             documentos
          </span> necesarios
        </p>
        <p style="font-size: 16px; font-weight: 600; color: #dc7134">Para más información o dudas comunicarse al Chat de Soporte</p>
        
        <p style="font-size: 16px; font-weight: 600; color: #dc7134">
          Horarios de atención del chat<br>
          <span style="color:#007bff;">De lunes a viernes de 9am a 5pm y sábado de 10am a 1pm</span>
        </p>
      
      </div>
    </div>
    <div class="login__bg"></div>
    <Popup ref="forgotpwd" size="sm">
      <h3 class="text-center title-forgot-pwd">¿Olvidaste tu contraseña?</h3>
      <p
        class="forgot-pwd-text"
      >No te preocupes, ingresa a tu correo y un link de recuperación será enviado a tu bandeja de entrada.</p>
      <div class="form">
        <div class="form__group" style="margin-bottom: 0;">
          <label for="recoveryEmail" class="form__label">Correo electrónico</label>
          <input id="recoveryEmail" v-model="recoveryEmail" type="email" class="form__input" />
          <validation-error :validation="$v.recoveryEmail"></validation-error>
        </div>
        <div class="form__group text-right pt-5">
          <btn
            class="text-center btn-inline"
            type="default"
            text="Cancelar"
            @onClick="$refs.forgotpwd.toggleModal()"
          />
          <btn
            class="text-center btn-inline"
            type="primary"
            text="Enviar"
            @onClick="sendPwdConfirm"
          />
        </div>
      </div>
    </Popup>
    <Popup ref="resetpwdsent" size="sm">
      <div class="text-center">
        <h3 class="text-center title-forgot-pwd mb-3">Email enviado</h3>
        <p
          class="forgot-pwd-text"
        >Ingresa a tu correo electrónico, un link de recuperación será enviado a tu bandeja de entrada.</p>
        <img src="/img/icons/email-sent.svg" alt />
        <div class="form__group mt-5">
          <btn type="primary-block" text="OK" @onClick="$refs.resetpwdsent.toggleModal()" />
        </div>
      </div>
    </Popup>
    <Loader v-show="isLoading" />
    <Footer :absolute="true"/>
  </div>
</template>
<script>
import Popup from "../core/Popup";
import Btn from "../core/Button";
import Swal from "sweetalert2";
import Footer from "../core/Footer"
import { mapActions, mapState } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import ValidationError from "./misc/ValidationError";
import Loader from "../core/Loader";
import FileSaver from "file-saver";

export default {
  name: "Login",
  components: {
    Loader,
    Btn,
    Popup,
    ValidationError,
    Footer
  },
  data() {
    return {
      email: "",
      isLoading: false,
      recoveryEmail: "",
      password: "",
      passwordVisible: "password",
      loggin: true
    };
  },
  validations: {
    email: {
      required,
      email
    },
    password: {
      required
    },
    recoveryEmail: {
      required,
      email
    }
  },
  computed: {
   ...mapState({
      authenticated: state => state.auth.authenticated,
      userType: state => state.auth.userType
    }),
    showPasswordIcon() {
      let icon = "";
      if (this.passwordVisible == "password") {
        icon = "password-hidden.svg";
      } else {
        icon = "password-visible.svg";
      }
      return icon;
    }
  },
  methods: {
    ...mapActions(["authenticate", "logOut", "sendEmailPasswordRecovery"]),
    async logout() {
      await this.logOut();
    },
    donwloadFile(url){
    FileSaver.saveAs(url, "ListaDeDocumentos.pdf");
    },
    async handleAuth() {
      this.$v.password.$touch();
      this.$v.email.$touch();
      if (!this.$v.password.$invalid && !this.$v.email.$invalid) {
        try {
          this.loggin = false;
          await this.authenticate({
            email: this.email,
            password: this.password
          });
          if (this.authenticated) {
            if (this.userType == "APPLICANT") {
              this.$router.push("/home");
              this.$notify.success({
                message: "Bienvenido al sistema de solicitudes de club de golf",
                position: "bottom right",
                timeOut: 5000
              });
            } else {
              this.$router.push("/admin");
              this.loggin = true;
              this.$notify.success({
                message: "Bienvenido al Administrador del sistema de solicitudes de club de golf",
                position: "bottom right",
                timeOut: 5000
              });
            }
          }
        } catch (e) {
          this.loggin = true;
          this.showFailureMessage = true;
          let emessage = "";
          if (e.response) {
            emessage = e.response.data.error_description;
          }
          this.$notify.error({
            message: emessage,
            position: "top right",
            timeOut: 5000
          });
        }
      }
    },
    togglePwdIcon(icon) {
      if (icon) {
        this.passwordVisible = "text";
      } else {
        this.passwordVisible = "password";
      }
    },
    async sendPwdConfirm() {
      try {
        this.$v.recoveryEmail.$touch();
        if (this.$v.recoveryEmail.$invalid) {
          return;
        }
        this.$refs.forgotpwd.toggleModal();
        this.isLoading = true;
        const params = {
          email: this.recoveryEmail
        };
        const data = await this.sendEmailPasswordRecovery(params);

        if (data.status === 200) {
          this.$refs.resetpwdsent.toggleModal();
        }else {
          this.pushNotifyError();
        }

      }catch (error) {
        if (error && error.response && error.response.status === 404) {
          this.errorMessage();
        } else {
          this.pushNotifyError();
        }
      }finally {
        this.isLoading = false;
        this.recoveryEmail = "";
      }
    },
    errorMessage() {
      Swal.fire({
        title:
                "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans,serif; color: #dc7134'>¡ATENCIÓN!</span>",
        html:
                "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans,serif; color: #828282'>" +
                "<p>El correo eletrónico que ingreso no existe.</p>" +
                "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
                "</div>",
        allowOutsideClick: false,
        width: "50rem",
        padding: "2rem",
        confirmButtonText: "Ok",
        confirmButtonColor: "#dc7134",
        customClass: {
          confirmButton: "t1-btn t1-btn--primary-block"
        },
        onClose: () => {}
      });
    },
    pushNotifyError(){
      this.$notify.error({
        message: "Ha ocurrido un error, inténtalo más tarde.",
        position: "top right",
        timeOut: 15000
      });
    },
  },
  mounted() {
    this.logout();

  }
};
</script>
<style lang="scss">
$medium-grey: #828282;

.input-password {
  display: inline;
}

.btn-inline {
  display: inline;
  &:not(:last-child) {
    padding-right: 1.5rem;
  }
}

.show-password {
  position: absolute;
  margin-top: auto;
  margin-bottom: auto;
  padding-top: 1.1rem;
  padding-left: 0.5rem;
  display: inline;
}

.title-forgot-pwd {
  text-transform: uppercase;
  color: $medium-grey;
  font-weight: 400;
  font-family: Josefin Sans;
  font-size: 2rem;
}

.forgot-pwd-text {
  color: $medium-grey;
  font-size: 1.2rem;
  padding: 0.5rem 0.5rem;
  text-align: center;
}
</style>